import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { handleReferralFromSearchParams } from '../../utils/referralAttribution';

/**
 * Watches ?ref= on any route and records attribution via POST /public/referral/track.
 * Dedupe + in-flight coalescing live in referralAttribution.ts (Strict Mode safe).
 */
export function ReferralAttributionTracker() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (!params.get('ref')?.trim()) return;
    void handleReferralFromSearchParams(params);
  }, [location.pathname, location.search]);

  return null;
}
